const initialState = {
    selectedPackage: {},
    selectedAddons: [],
    addons: [],
    prices: {},
    quantity: {}
}

export const packages = {
    state: { ...initialState },
    reducers: {
        updateSelectedPackage(state, payload) {
            return {
                ...state,
                selectedPackage: { ...state.selectedPackage, ...payload }
            }
        },
        updateSelectedAddons(state, payload) {
            const checkedData = state.selectedAddons.find(selected => selected.prodId === payload.prodId) || state.selectedAddons.find(selected => selected.name === payload.name)
            let filteredSelection;
            if (checkedData) {
                const currfilteredSelection = state.selectedAddons.
                    filter(selection => selection.name.toLowerCase() !== payload.name.toLowerCase())
                    .filter(selected => selected.prodId !== payload.prodId);
                if (payload?.type === 'checkbox' && !payload.checked) {
                    filteredSelection = currfilteredSelection;
                }
                else {
                    filteredSelection = [...currfilteredSelection, payload]
                }
            } else {
                filteredSelection = [...state.selectedAddons, payload];
            }

            return {
                ...state,
                selectedAddons: filteredSelection
            }
        },
        updateAddons(state, payload) {
            return {
                ...state,
                addons: [...state.addons, ...payload]
            }
        },
        updateAddonsQuantity(state, payload) {
            return {
                ...state,
                quantity: { ...state.quantity, ...payload }
            }
        },
        updatePrice(state, payload) {
            return {
                ...state,
                prices: { ...state.prices, ...payload }
            }
        },
        clearPackages() {
            return {
                ...initialState
            }
        },
        removeAll(state, payload) {
            const checkedData = state.selectedAddons.find(selected => selected.name === payload)
            let filteredSelection;
            if (checkedData) {
                filteredSelection = state.selectedAddons.filter(selection => selection.name.toLowerCase() !== payload.toLowerCase())
            } else {
                filteredSelection = state.selectedAddons;
            }
            return {
                ...state,
                selectedAddons: filteredSelection
            }
        }
    }
}
